import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  REQUEST_UPLOAD_MDS_CSV_TEMPLATE,
  SUCCESS_UPLOAD_MDS_CSV_TEMPLATE,
  FAILURE_UPLOAD_MDS_CSV_TEMPLATE,
  RESET_UPLOAD_MDS_CSV_TEMPLATE,
  LOADING_UPLOAD_MDS_CSV_TEMPLATE,
} = therapyPlanningAction;

function* uploadMdsCsvTemplate(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_UPLOAD_MDS_CSV_TEMPLATE });
    const response = yield call(therapyPlanningService.uploadCSVTemplateMds, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_UPLOAD_MDS_CSV_TEMPLATE, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_UPLOAD_MDS_CSV_TEMPLATE, payload: error });
  }
}

function* uploadMdsCsvTemplateSaga() {
  yield takeEvery(REQUEST_UPLOAD_MDS_CSV_TEMPLATE, uploadMdsCsvTemplate);
}

export default uploadMdsCsvTemplateSaga;
